// extracted by mini-css-extract-plugin
export var orderDetails = "_rg-2";
export var orderImage = "_rg-1";
export var orderMeta = "_rg-3";
export var orderSummary = "_rg-0";
export var rightArrow = "_rg-4";